import { Injectable } from '@angular/core';
import { InterfacectrlmapService } from './interfacectrlmap.service';
import { MarketGeofenceInterface, MarketRouteInterface, MarketUnitInterface, MarketPoiInterface, LatLngInterface, MarketServiceInterface, UnitOrDriverInterface } from '../models/models.interface';
import {
    VehicleInterface, ServiceInterface, SiteInterface, TrackInterface,
    MarketInterface
} from '../models/models.interface'
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { element } from 'protractor';
import { AppConfiguration } from '../config/app-configuration';
import { resolve } from 'dns';
import { AppConfigService } from '../app-config.service.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
})
export class MapInformationService {
    public Token = '';
    // private appConfig: AppConfiguration;
    private appConfig;
    public baseURI= ""
    public vendorURI = "";
    // private urlInformation = 'https://wsapi.foresightgps.com/ForesightFlexAPI.ashx?';
    // private urlClientInformation = 'http://cube-mia.com/apicubeedge/';
    constructor(
        private http: HttpClient,
        private _interfacectrlmapService: InterfacectrlmapService,
        private appConfigP: AppConfiguration,
        private AppConfigService:AppConfigService,
        private toast: ToastService,
        private pipeDate: DatePipe,
    ) {
        
        this.baseURI = this.AppConfigService.apiBaseUrl;
        // this.vendorURI = this.AppConfigService.apiMasterVendorURL;
        this.appConfig = appConfigP;
        // this.appConfig = environment;
        // this.GetToken();
    }

    // GetToken(): void {
    //     var userName =  this.appConfig.userName // "qa@sfc-mia.com";
    //     var pass = this.appConfig.pass // "123456";
    //     this.http.post(this.appConfig.urlClientInformation + 'user',
    //         {
    //             "username": userName,
    //             "password": pass
    //         }
    //     ).subscribe((data: any) => {
    //         this.Token = data.token;
    //     }, (error: any) => {
    //     });
    // }

    // GetTokenPromise():Promise<any>{
    //     return new Promise((resolve, reject) => { 
    //         var userName =  this.appConfig.userName // "qa@sfc-mia.com";
    //         var pass = this.appConfig.pass // "123456";
    //         this.http.post(this.appConfig.urlClientInformation + 'user',
    //             {
    //                 "username": userName,
    //                 "password": pass
    //             }
    //         ).subscribe((data: any) => {
    //             resolve (this.Token = data.token);
    //         }, (error: any) => {
    //             reject(error)
    //         });
    //     })
    // }

    GetVehicles(search: string = ""): VehicleInterface[] {
        this._interfacectrlmapService.ShowLoading("Espere porfavor", "Cargando Data");
        this._interfacectrlmapService.HideLoading();
        let data = [
            { Id: 1, Employee: 'E1', Name: 'N1', Lat: 'Lat1', Long: 'Long1' },
            { Id: 2, Employee: 'E2', Name: 'N1', Lat: 'Lat2', Long: 'Long2' },
            { Id: 3, Employee: 'E3', Name: 'N1', Lat: 'Lat3', Long: 'Long3' },
            { Id: 4, Employee: 'E4', Name: 'N1', Lat: 'Lat4', Long: 'Long4' },
        ];
        return data;
    }
    GetVehiclesByID(ids: number[]): MarketInterface[] {
        let data = [
            { ID: 1, Lat: 19.491950, lng: -99.694015, name: "test", zoom: 9, icon: "carro.png" },
            { ID: 2, Lat: 19.290960, lng: -99.653025, name: "otro", zoom: 9, icon: "carro.png" }
        ];
        return data;
    }

    GetAllVehicles(allSelected: boolean): Observable<MarketUnitInterface[]> {
        console.log("URL?? ", this.appConfig.urlInformation)
        return this.http.post(this.appConfig.urlInformation, {
            "conncode": this.appConfig.conncode,
            "method": "GetUnits",
            "userid": this.appConfig.fleetuserid
        },
        {
            headers: {
                "Authorization": "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),
            }
        })
        .pipe(
            map((data: any): MarketUnitInterface[] => {
                let resul: MarketUnitInterface[] = [];
                let contador=0
                data.ForesightFlexAPI.DATA.forEach((element, index, array) => {
                    this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',
                    { 
                        "method":"Get_VehiclesByDeviceId",
                        "deviceid":element.devicename
                    }) 
                    .subscribe(resp=>{
                        if(resp[0] != undefined){
                            resul.push({
                                UnitID: parseInt(element.UnitID),
                                Lat: parseFloat(element.ylat),
                                lng: parseFloat(element.xlong),
                                name: element.UnitName,
                                zoom: 9,
                                icon: "carro.png",
                                CompanyName: element.CompanyName,
                                SubFleetName: element.SubFleetName,
                                GroupName: element.GroupName,
                                Course: element.Course,
                                OperatorName: resp[0].EMPLOYEE,
                                PLanName: element.PLanName,
                                callfignName: element.callfignName,
                                isdeleted: (element.isdeleted.toLocaleLowerCase() == "true"),
                                // lasttime: this.GetDateTimewithFormat(new Date(element.lasttime),'yyyymmdd'),
                                lasttime:this.pipeDate.transform(element.lasttime, 'MM/dd/yyyy, hh:mm a'),
                                location: element.location,
                                odometer: parseFloat(element.odometer),
                                plateno: element.plateno,
                                speed: parseFloat(element.speed),
                                show: allSelected,
                                make:resp[0].MAKE,
                                model:resp[0].MODEL,
                                color:resp[0].COLOR, //
                                vinnumber:resp[0].VINNUMBER,
                                plateNumber:resp[0].LINCPLATE,
                                // registryexpire: this.GetDateTimewithFormat(new Date(resp[0].REGEXPIRATIONDATE),'yyyymmdd'),
                                registryexpire: this.pipeDate.transform(element.lasttime, 'MM/dd/yyyy'),
                                trackingDevice: resp[0].TRACKINGDEVICENUMBER,
                                ignition:element.ignition,
                                notes:resp[0].NOTES, //
                                year:resp[0].YEAR,
                                resources:resp[0].EMPLOYEE, //
                                type:resp[0].EMPLOYEE_CODE, //
                                id:resp[0].ID
                            });
                        }
                        contador++
                        if(data.ForesightFlexAPI.DATA.length == contador){

                            if(resul.length == 0){
                                this.toast.warning("Your Company does not have any vehicles associated, please contact CUBE for more information")
                            }
                            return resul
                        }
                    })
                });
                return resul;

            })
        );
    }

    GetAllVehiclesPolarix(allSelected: boolean): Observable<MarketUnitInterface[]> {
        return this.http.post(this.appConfig.urlInformation, {
            "conncode": this.appConfig.conncode,
            "method": "GetUnits",
            "userid": this.appConfig.fleetuserid
        },
        {
            headers: {
                "Authorization": "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),
            }
        })
        .pipe(
            map((data: any): MarketUnitInterface[] => {
                return data.ForesightFlexAPI.DATA;
            })
        );
    }

    TestGetAllVehiclesPolarix(allSelected: boolean, subfleetid): Observable<MarketUnitInterface[]> {
        return this.http.post(this.appConfig.urlInformation, {
            "conncode": this.appConfig.conncode,
            "method": "GetUnits",
            // "subfleet": subfleetid
            "subfleet": 304
        },
        {
            headers: {
                "Authorization": "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),
            }
        })
        .pipe(
            map((data: any): MarketUnitInterface[] => {
                if(data.ForesightFlexAPI.DATA.length > 0){
                    return data.ForesightFlexAPI.DATA;
                } else {
                    let datos = [data.ForesightFlexAPI.DATA]
                    return datos
                }
            })
        );
    }
    GetAllVehiclesPolarixSinSubscribe(): Observable<any> {
        return this.http.post(this.appConfig.urlInformation, {
            "conncode": this.appConfig.conncode,
            "method": "GetUnits",
            "userid": this.appConfig.fleetuserid
        },
        {
            headers: {
                "Authorization": "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),
            }
        })
    }

    AddVehiclePolarix(name,subfleetid): Observable<any> {
        return this.http.post(this.appConfig.urlInformation, {
            "conncode": this.appConfig.conncode,
            "method": "AddVehicle",
            "userid": this.appConfig.fleetuserid,
            "platenumber":name,
            "subfleetid":subfleetid,
            "companyid":110,
        },
        {
            headers: {
                "Authorization": "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),
            }
        })
    }

    SearchSWO(value){
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex', { "method":"Get_SWO_ServiceListByName ","name":value, top:100} )
    }

    GetTaskCategories() {
        return this.http.post<any>(this.baseURI + '/TaskCategory', {});
      }

    AddSubFleetPolarix(name): Observable<any> {
        return this.http.post(this.appConfig.urlInformation, {
            "conncode": this.appConfig.conncode,
            "method": "AddSubFleet",
            "userid": this.appConfig.fleetuserid,
            "name":name,
            "companyid":110,
        },
        {
            headers: {
                "Authorization": "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),
            }
        })
    }

    AssignDeviceToVehiclePolarix(vehid,devicename): Observable<any> {
        return this.http.post(this.appConfig.urlInformation, {
            "conncode": this.appConfig.conncode,
            "method": "AssignDeviceToVehicle",
            "userid": this.appConfig.fleetuserid,
            "vehid":vehid,
            "devicename":devicename,
        },
        {
            headers: {
                "Authorization": "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),
            }
        })
    }

    GetPOI(search: string = ""): ServiceInterface[] {
        this._interfacectrlmapService.ShowLoading("Espere porfavor", "Cargando Data");
        this._interfacectrlmapService.HideLoading();
        let data = [
            { Id: 1, Time: 'E1', Site: 'N1', AssignedTo: 'AssignedTo1' },
            { Id: 2, Time: 'E2', Site: 'N1', AssignedTo: 'AssignedTo2' },
            { Id: 3, Time: 'E3', Site: 'N1', AssignedTo: 'AssignedTo3' },
            { Id: 4, Time: 'E4', Site: 'N1', AssignedTo: 'AssignedTo4' },
        ];
        return data;
    }

    GetMilesLog(vehid,startdateandtime,enddateandtime): Observable<any> {
        return this.http.post(this.appConfig.urlInformation, {
            "conncode": this.appConfig.conncode,
            "method": "getvehiclemileagehistory",
            "userid": this.appConfig.fleetuserid,
            "vehid":vehid,
            "startdateandtime": this.GetDateTime(startdateandtime, "yyyymmdd"),
            "enddateandtime":this.GetDateTime(enddateandtime, "yyyymmdd")
        },
        {
            headers: {
                "Authorization": "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),
            }
        })
    }

    GetPOIByID(ids: number[]): MarketInterface[] {
        let data = [
            { ID: 1, Lat: 19.491950, lng: -99.694015, name: "test", zoom: 9, icon: "service.gif" },
            { ID: 2, Lat: 19.290960, lng: -99.653025, name: "otro", zoom: 9, icon: "service.gif" }
        ];
        return data;
    }

     // Regresa todos los services sites
    GetAllInfo(method:any):Observable<any>{
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',{ "method":method})
    }

    GetAllInfoDinamicoEstimate(method:any, name:any):Observable<any>{
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',{ "method":method,"astimateName":name,estimateID:null})
    }

    GetAllInfoDinamico(method:any, name:any):Observable<any>{
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',{ "method":method,"name":name})
    }

    InfoFiltrada(method:any,campo:any):Observable<any>{
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',{ "method":method, EMPLOYEENAME:campo})
    }

    GetSitesByID(method:any,campo:any):Observable<any>{
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',{ "method":method, "siteid":campo})
    }

    GetOrderByID(method:any,campo:any):Observable<any>{
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',{ "method":method, "id":campo})
    }

    GetAllInfoFiltro(method:any,campo:any):Observable<any>{
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',{ "method":method})
    }

    GetInfo(method:any):Observable<any>{
        return this.http.post(this.baseURI + method,{})
    }

    SendNotification(obj:any):Observable<any>{
        return this.http.post(this.baseURI + '/Notifications/NotificationsTemplateA', obj)
    }

    SendNotificationB(obj:any):Observable<any>{
        return this.http.post(this.baseURI + '/Notifications/NotificationsTemplateB', obj)
    }

    SendNotificationLetterType(obj:any):Observable<any>{
        return this.http.post(this.baseURI + '/Notifications/NotificationGenericTemplate', obj)
    }

    InsertSWO(informacion:Object):Observable<any>{
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',informacion)
    }

    GeneralService(obj:Object){
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',obj);
    }

    GetRequestByName(name) {
        return this.http.post<any>(this.baseURI + "Contacts/Get_AllContactsByName", {name: "Hector Hernandez" });
      }
      
      
    GetPMTask(assetID,serviceDetailID) {
    return this.http.post<any>(this.baseURI + "/ServiceWorkOrderDetail/GetServiceDetailPMTask", {systemid: assetID, servicedetailid:serviceDetailID});
    }

    GetPO(metodo,valor) {
    return this.http.post<any>(this.baseURI + metodo, {projectid: valor});
    }

    GetInfoDinamica(metodo,valor) {
        return this.http.post<any>(this.baseURI + metodo, {projectid: valor});
    }

    SaveServiceManagement(metodo,valor) {
        return this.http.post<any>(this.baseURI + metodo, valor);
    }

    GetAllInfoDinamica(metodo,valor) {
        return this.http.post<any>(this.baseURI + metodo, {serviceid:valor});
    }
    
    SaveInfoSites(datos):Observable<any> {
        // console.log(datos)
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',datos)
    }

    duplicateImage(from, to){
        console.log(from)
        console.log(to)
        return this.http.post(this.baseURI + '/DownloadFile/DuplicateSystem', { "from": from, "to" : to } )
      }


    saveDataTranfer(datos):Observable<any> {
        // console.log(datos)
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex/Payment/create',datos)
    }

    SearInAI(datos):Observable<any> {
        // console.log(datos)
        return this.http.get("http://cubeai.cube-usa.com:3000/cubeai/:"+ datos)
    }

    SearInAICubeBox(url, datos):Observable<any> {
        console.log(datos)
        return this.http.get(url + datos)
    }

    MethodCallApiFlex(datos):Observable<any> {
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',datos)
    }

    MethodCallApiFlexCubeWorks(datos):Observable<any> {
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex/CallFlexCubeWorks',datos)
    }

    getParameters(datos):Observable<any> {
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',{method:"GetProcedureXMLParameters",procedurename: datos})
    }

    getProjectionBoard(){
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',{method:"Get_SalesForecastProjectionBoard"})
    }

    NotifyTechnician(serviceid,mailto,subject){
        return this.http.post(this.baseURI + '/Notifications/NotificationServiceCust', { serviceid: serviceid, mailto: mailto, subject:subject } )
    }

    NotifyCustomer(serviceid,mailto){
        return this.http.post(this.baseURI + '/Notifications/NotificationServiceCust', { serviceid: serviceid, mailto: mailto, subject:'A new service ticket has been opened' } )
    }

    GetDocument(filepath):Observable<any> {
        return this.http.post(this.baseURI + '/DownloadFile/Download', { filename: filepath } );
    }

    GetDocumentThumImg(filepath):Observable<any> {
        return this.http.post(this.baseURI + '/DownloadFile/Download', { filename: filepath } );
    }

    DownloadDocument(filepath): Observable<any>{
        return this.http.post(this.baseURI + '/DownloadFile/Download', { filename: filepath });
    }

    SaveDocument(filestring,id){
        return this.http.post(this.baseURI + '/DownloadFile/Upload', { filestring: filestring, doctype: 'swodocs', id: id })
    }

    SaveDocumentDinamico(file, id,doctype){
        return this.http.post(this.baseURI + '/DownloadFile/Upload', { filestring: file, doctype: doctype, id: id })
    }

    // Regresa todos los services sites
    GetAllInfoOldFormat(method:any):Observable<any>{
        return this.http.post(this.baseURI + method,{})
    }

    // Regresa todos los services sites
    GetAllPOI(allSelected?: boolean):Observable<any>{
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',{ "method":"Get_ServiceSites"})
    }

    GetActivitySalesLeadProject(id){
        return this.http.post<any>(this.baseURI + '/FlexIntegration/CallExtFlex', { method: 'Get_ActivityListByProject', projectid: id } );
    }

    InsertUpdateActivity(model) {
        return this.http.post<any>(this.baseURI + '/Activity/InsertUpdateActivity', model);
      }

    GetProjectActivity(projectid) {
        return this.http.post<any>(this.baseURI + '/Activity/GetActivityListByProject', { projectid: projectid });
    }

    GetProjectActivityFlex(projectid){
        return this.http.post<any>(this.baseURI + '/FlexIntegration/CallExtFlex', { method: 'Get_ActivityListByProject', projectid: projectid });
    }
    
    // Regresa todos los services sites
    GetLogs(allSelected?: boolean):Observable<any>{
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',{ "method":"Get_Log"})
    }

    // Trae todos los services work order 
    GetAllService(allSelected?: boolean, unitOrDrier?: UnitOrDriverInterface, startdate?: Date,enddate?: Date,): Observable<any> {
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',
            {
                "method":"Get_ServiceWorkOrderServiceSitesByDate",
                "startdate": this.GetDateTime(startdate, "yyyymmdd") + " 00:01",
                "enddate":this.GetDateTime(startdate, "yyyymmdd") + " 23:59:59"
            }
        )
    }

    GetVehiclesCubeMia():Observable<any>{
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex',
        { 
            "method":"Get_VehiclesByDeviceId",
            "deviceid":"864251020154930"
        }
        ) 
    }
    
    GetGeofence(search: string = ""): SiteInterface[] {
        this._interfacectrlmapService.ShowLoading("Espere porfavor", "Cargando Data");
        this._interfacectrlmapService.HideLoading();
        let data = [
            { Id: 1, Name: 'N1', Customer: 'Customer1' },
            { Id: 2, Name: 'N1', Customer: 'Customer2' },
            { Id: 3, Name: 'N1', Customer: 'Customer3' },
            { Id: 4, Name: 'N1', Customer: 'Customer4' },
        ];
        return data;
    }

    GetGeofenceByID(ids: number[]): MarketGeofenceInterface[] {
        let data = [
            {
                ID: 1,
                Latlng: [
                    { lat: 0, lng: 10 },
                    { lat: 0, lng: 20 },
                    { lat: 10, lng: 20 },
                    { lat: 10, lng: 10 },
                    { lat: 0, lng: 10 }
                ],
                name: "test", zoom: 9, icon: "site.png"
            },
            {
                ID: 2,
                Latlng: [
                    { lat: 0, lng: 10 },
                    { lat: 0, lng: 20 },
                    { lat: 10, lng: 20 },
                    { lat: 10, lng: 10 },
                    { lat: 0, lng: 10 }
                ],
                name: "otro", zoom: 9, icon: "site.png"
            }
        ];
        return [];
    }

    GetAllGeofence(allSelected: boolean): Observable<MarketGeofenceInterface[]> {
        return this.http.get(this.appConfig.urlInformation + 'conncode=PolarixUSA&method=GetZones&company=115').
            pipe(
                map((data: any): MarketGeofenceInterface[] => {
                    let result: MarketGeofenceInterface[] = [];
                    data.ForesightFlexAPI.DATA.forEach((element, index, array) => {
                        result.push({
                            ID: parseInt(element.ID),
                            Latlng: this.GetVertices(element.Vertices),
                            name: element.ZoneName,
                            zoom: 9,
                            icon: "site.png",
                            puted: allSelected,
                        });
                    });
                    return result;
                })
            );
    }

    GetRoute(allSelected: boolean, unitOrDrier: UnitOrDriverInterface, dateFrom: Date, dateToRoute: Date): Observable<MarketRouteInterface[]> {
        //return this.http.get(this.appConfig.urlInformation + 'conncode=PolarixUSA&method=HistoryOfUnit&tobjectid=' + unitOrDrier.ID + '&startdate=' + this.GetDateTime(dateFrom, "yyyymmdd") + '&enddate=' + this.GetDateTime(dateToRoute, "yyyymmdd")).
        let headers = new HttpHeaders();
        headers = headers.append("Authorization", "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass));
       
       
        return this.http.post(this.appConfig.urlInformation, {
            "conncode": this.appConfig.conncode,
            "method": "HistoryOfUnit",
            "tobjectid": unitOrDrier.ID,
            "userid": this.appConfig.fleetuserid,
            "startdate": this.GetDateTime(dateFrom, "yyyymmdd"),
            "enddate": this.GetDateTime(dateToRoute, "yyyymmdd")
        },
        {
            headers
        })          
        .pipe(
                map((data: any): MarketRouteInterface[] => {
                    let result: MarketRouteInterface[] = [];
                    const auxData = data.ForesightFlexAPI.DATA;
                    if (auxData.length != undefined) {
                        result.push({
                            ID: parseInt(auxData[0].id),
                            Latlng: this.GetVerticesRoutes(auxData),
                            name: auxData[0].Name,
                            zoom: 9,
                            icon: "site.png",
                            puted: allSelected,
                            IsDelete: false,
                            show:false,
                            today:""
                        });
                    }
                    else {
                        result.push({
                            ID: parseInt(auxData.id),
                            Latlng: [{ lat: parseFloat(auxData.ylat), lng: parseFloat(auxData.xlong) }],
                            name: auxData.Name,
                            zoom: 9,
                            icon: "site.png",
                            puted: allSelected,
                            IsDelete: false,
                            show:false,
                            today:""
                        });
                        //result[0].Latlng.push({ lat: parseFloat(auxData.ylat)+10, lng: parseFloat(auxData.xlong) +10 });
                    }

                    return result;
                })
            );
    }

    GetRouteByID(ids: number[]): MarketRouteInterface[] {
        let data = [
            {
                ID: 1,
                Latlng: [
                    { lat: 0, lng: 10 },
                    { lat: 0, lng: 20 },
                    { lat: 10, lng: 20 },
                    { lat: 10, lng: 10 },
                    { lat: 0, lng: 10 }
                ],
                name: "test", zoom: 9, icon: "site.png"
            },
            {
                ID: 2,
                Latlng: [
                    { lat: 0, lng: 10 },
                    { lat: 0, lng: 20 },
                    { lat: 10, lng: 20 },
                    { lat: 10, lng: 10 },
                    { lat: 0, lng: 10 }
                ],
                name: "otro", zoom: 9, icon: "site.png"
            }
        ];
        return [];
    }

    private GetVertices(Vertices: string): LatLngInterface[] {
        let latLon: LatLngInterface[] = [];
        Vertices.replace(/[{()} ]/g, '').split(';').forEach((element: any) => {
            const values = element.split(',');
            latLon.push({
                lat: parseFloat(values[0]),
                lng: parseFloat(values[1]),
            });
        });
        return latLon;
    }

    private GetVerticesRoutes(Vertices: any): LatLngInterface[] {
        let latLon: LatLngInterface[] = [];
        Vertices.forEach((element: any) => {
            latLon.push({
                lat: parseFloat(element.ylat),
                lng: parseFloat(element.xlong),
            });
        });
        return latLon;
    }

    GetAllUnitOrDriver(search: string): Observable<UnitOrDriverInterface[]> {
        return this.http.get(this.appConfig.urlInformation + 'conncode=PolarixUSA&method=UnitsAndOperators&company=115&searchname=' + search).
            pipe(
                map((data: any): UnitOrDriverInterface[] => {
                    let result: UnitOrDriverInterface[] = [];
                    data.ForesightFlexAPI.DATA.forEach((element, index, array) => {
                        result.push({
                            ID: parseInt(element.id),
                            Name: element.name
                        });
                    });
                    return result;
                })
            );
    }

    GetAllUnit(search: string): Observable<UnitOrDriverInterface[]> {

        let headers = new HttpHeaders();
        headers = headers.append("Authorization", "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass));
       
       
        return this.http.post(this.appConfig.urlInformation, {
            "conncode": this.appConfig.conncode,
            "method": "Units",
            "searchname": search,
            "userid": this.appConfig.fleetuserid
        },
        {
            headers
        })
        .pipe(
            map((data: any): UnitOrDriverInterface[] => {
                let result: UnitOrDriverInterface[] = [];
                if (Array.isArray(data.ForesightFlexAPI.DATA)) {
                    data.ForesightFlexAPI.DATA.forEach((element, index, array) => {
                        result.push({
                            ID: parseInt(element.id),
                            Name: element.name
                        });
                    }) 
                }
                else {
                    result.push({
                        ID: parseInt(data.ForesightFlexAPI.DATA.id),
                        Name: data.ForesightFlexAPI.DATA.name
                    });
                }
                return result;
            })
        );

        // return this.http.get(this.appConfig.urlInformation + 'conncode=PolarixUSA&method=Units&userid='+ this.appConfig.fleetuserid + '&searchname=' + search).
        //     pipe(
        //         map((data: any): UnitOrDriverInterface[] => {
        //             let result: UnitOrDriverInterface[] = [];
        //             data.ForesightFlexAPI.DATA.forEach((element, index, array) => {
        //                 result.push({
        //                     ID: parseInt(element.id),
        //                     Name: element.name
        //                 });
        //             });
        //             return result;
        //         })
        //     );
    }

    private GetDateTime(dateTime: Date, fomat: string): string {
        let result = '';
        switch (fomat) {
            case "yyyymmdd":
                result = dateTime.getFullYear() + this.completeLeft((dateTime.getMonth() + 1).toString(), 2) + this.completeLeft(dateTime.getDate().toString(), 2);
                break;
        }
        return result;
    }

    private GetDateTimewithFormat(dateTime: Date, fomat: string): string {
        let result = '';
        switch (fomat) {
            case "yyyymmdd":
                result = dateTime.getFullYear() + "/" + this.completeLeft((dateTime.getMonth() + 1).toString(), 2) + "/" +this.completeLeft(dateTime.getDate().toString(), 2);
                break;
        }
        return result;
    }

    private completeLeft(value: string, length: number, chart: String = '0'): string {
        let result = value;
        // while (result.length < length) {
        //     result += chart;
        // }
        if (Number(result) <= 9) {
            result = '0' + result;
        }
        return result;
    }

    getEmailTemplate(){
     return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex', {"method":"GetNotificationEmailTemplate "})
    }

    insertUpdateEmailTemplate(obj){
     return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex', obj) 
    }

    GetVendorsPart(id){
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex', {method: 'Get_VendorsPartsByVendorId', vendorid: id}) 
    }

    syncVendorPart(partnumber, partid, update, vendormaster, mastertoken){
        partnumber = encodeURIComponent(partnumber); 
        return this.http.get(this.baseURI + '/Apls/api?partnumber='+partnumber+'&vendorpartid='+partid+'&updateprice='+update+'&vendormaster='+vendormaster+'&mastertoken='+mastertoken, {})
    }

    syncVendorPart2(partnumber, partid, update, vendormaster, mastertoken){
        partnumber = encodeURIComponent(partnumber); 
        
        return this.http.get(this.vendorURI + '?partnumber='+partnumber+'&vendorpartid='+partid+'&updateprice='+update+'&vendormaster='+vendormaster+'&mastertoken='+mastertoken, {
            headers: new HttpHeaders()
                        .set('Authorization', 'Bearer ' + localStorage.getItem('token'))
                        .set("Authorization", "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),)
        })
    }
 
    sendOrderVendor(mastertoken, parameters){
        return this.http.get(this.vendorURI + '/orderSubmit?parameters='+parameters+'&mastertoken='+mastertoken, {
            headers: new HttpHeaders()
                        .set('Authorization', 'Bearer ' + localStorage.getItem('token'))
                        .set("Authorization", "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),)
        })
    }

    GetCategories(manufacturerId){
        return this.http.get(this.vendorURI + `/getCategories?parameters={ManufacturerIds:[${manufacturerId}]}`, {
            headers: new HttpHeaders()
                        .set('Authorization', 'Bearer ' + localStorage.getItem('token'))
                        .set("Authorization", "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),)
        })
    }
    
    GetManufacturer(categoryId, productTypeId,){
        return this.http.get(this.vendorURI + `/getManufacturer?parameters={ManufacturerIds:[],CategoryIds:[${categoryId}],ProductTypeIds:[${productTypeId}]}`, {
            headers: new HttpHeaders()
                        .set('Authorization', 'Bearer ' + localStorage.getItem('token'))
                        .set("Authorization", "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),)
        })
    }

    GetproductType(categoryId, manufacturerId){
        return this.http.get(this.vendorURI + `/getProductTypes?parameters={ManufacturerIds:[${manufacturerId}],ProductTypeIds:[],CategoryIds:[${categoryId}]}`, {
            headers: new HttpHeaders()
                        .set('Authorization', 'Bearer ' + localStorage.getItem('token'))
                        .set("Authorization", "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),)
        })
    }

    GetByCategoryId(categoryId, productTypeId, manufacturerId){
        return this.http.get(this.vendorURI + `/getProductByCategory?parameters={ManufacturerIds:[${manufacturerId}],CategoryIds:[${categoryId}],ProductTypeIds:[${productTypeId}]}`, {
            headers: new HttpHeaders()
                        .set('Authorization', 'Bearer ' + localStorage.getItem('token'))
                        .set("Authorization", "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),)
        })
    }

    GetProductByNumber(partnumber, vendormaster, mastertoken){
        partnumber = encodeURIComponent(partnumber); 
        return this.http.get(this.vendorURI + `/getProductByNum?partnumber=${partnumber}&vendormaster=${vendormaster}&mastertoken=${mastertoken}`, {
            headers: new HttpHeaders()
                        .set('Authorization', 'Bearer ' + localStorage.getItem('token'))
                        .set("Authorization", "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),)
        })
    }

    GetHelpSteps(component_name):Observable<any> {
        let info = {
            method: "GetOmboarding_Hints",
            component_name: component_name
        }
        return this.http.post(this.baseURI + '/FlexIntegration/CallExtFlex', info)
    }
}